export default __webpack_public_path__ + "static/media/DashboardGreenSVG.30aa2562.svg";